import { useBasketService } from "@shared/modules/basket/context/BasketServiceContext";
import { IBasket } from "@shared/modules/basket/interfaces/IBasket";
import CartSeatItem from "../CartSeatItem/CartSeatItem.web";
import CartLocationItem from "../CartLocationItem/CartLocationItem.web";
import CartWaitlistItem from "../CartWaitlistItem/CartWaitlistItem.web";
import { CartItemProps } from "./CartItem.props";

const CartItem = (props: CartItemProps) => {
  const { formattedData } = props;
  const { isWaitlist } = useBasketService<IBasket>();

  return (
    <>
      {formattedData.seat && !isWaitlist && <CartSeatItem {...props} />}
      {formattedData.location && !isWaitlist && <CartLocationItem {...props} />}
      {isWaitlist && <CartWaitlistItem {...props} />}
    </>
  );
};

export default CartItem;
